import React, { useState } from 'react';

import { createLinkToken } from 'api/hris-integration';
import Spinner from 'components/spinner';
import MergeLink from 'components/import-data-page/merge-link';
import { Report } from 'graphql-api';

function HRISIntegrationButton({
  report,
  integration
}: {
  report: Report;
  integration: string;
}): JSX.Element {
  const [linkToken, setLinkToken] = useState<string | undefined>(undefined);
  const [processing, setProcessing] = useState<boolean>(false);

  async function handleHRISIntegrationClick(): Promise<void> {
    setProcessing(true);
    const token = await createLinkToken(report.id, integration);
    setLinkToken(token);
  }

  return (
    <>
      <button
        className="btn-secondary"
        onClick={() => {
          void handleHRISIntegrationClick();
        }}
        disabled={processing}>
        Connect
        {processing && <Spinner className="ml-2" />}
      </button>
      {linkToken !== undefined && (
        <MergeLink
          report={report}
          key={`merge-connect-${linkToken}`}
          linkToken={linkToken}
          integration={integration}
          setProcessing={setProcessing}
        />
      )}
    </>
  );
}

export default HRISIntegrationButton;
